import { serviceHost } from "../../common/const";
import ServiceRequest from "../../utils/service-request";

export const locationWise = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/locationWise",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
